import { getItem } from "@/utils/storage.js";
import responseHandler from "@/utils/responseHandler.js";
import router from "@/router";
import api from "@/utils/api.js";

export const getAsset = async({ commit }, payload) => {
    try {
        const response = await api.getAsset(payload);
        const { data } = response.data;
        await commit("SET_ASSET", data);
        return true;
    } catch (error) {
        responseHandler.handleError(error);
        return false;
    }
};

export const createAsset = async({ dispatch }, payload) => {
    const id = getItem("org_details")._id;
    try {
        const response = await api.createAsset(payload);
        const { _id } = response.data.data;
        dispatch("organisationModule/getOrganisationProfile", id, { root: true });
        await dispatch("getAsset", _id);
        router.push({
            name: "CreateAssetInfo",
            query: { asset: _id },
        });
        return true;
    } catch (error) {
        responseHandler.handleError(error);
        return false;
    }
};

export const updateAsset = async({ dispatch }, payload) => {
    const id = getItem("org_details")._id;
    try {
        const response = await api.updateAsset(payload);
        const { _id } = response.data.data;
        dispatch("organisationModule/getOrganisationProfile", id, { root: true });
        await dispatch("getAsset", _id);
        return true;
    } catch (error) {
        responseHandler.handleError(error);
        return false;
    }
};

export const deleteFounder = async({}, { id, asset }) => {
    try {
        const response = await api.deleteFounder({ id, asset });
        return response;
    } catch (error) {
        responseHandler.handleError(error);
        return error;
    }
};

export const getTokenRequest = async({ commit }) => {
    try {
        const response = await api.getTokenRequests();
        const { requests } = response.data.data;
        const publicTokenRequest = requests.filter(
            (request) => request.type === "Public"
        );
        await commit("SET_TOKEN", publicTokenRequest[0]);
        return true;
    } catch (error) {
        responseHandler.handleError(error);
        return false;
    }
};

export const createTokenRequest = async({ dispatch }, payload) => {
    const id = getItem("org_details")._id;
    try {
        const response = await api.createTokenRequest(payload);
        const { message } = response.data;
        dispatch(
            "showToast", { description: message, display: true, type: "success" }, { root: true }
        );
        dispatch("organisationModule/getOrganisationProfile", id, { root: true });
        await dispatch("getTokenRequest");
        // await dispatch("getAsset", payload.asset_id);
        return true;
    } catch (error) {
        responseHandler.handleError(error);
        return false;
    }
};

export const updateTokenRequest = async({ dispatch }, payload) => {
    try {
        const response = await api.updateTokenRequest(payload);
        const { message } = response.data;
        dispatch(
            "showToast", { description: message, display: true, type: "success" }, { root: true }
        );
        await dispatch("getTokenRequest");
        return true;
    } catch (error) {
        responseHandler.handleError(error);
        return false;
    }
};

export const searchAsset = async({ commit }, payload) => {
    try {
        const response = await api.searchAsset(payload);
        const { data } = response.data;
        commit("SET_ASSET_SEARCH", data);
        return true;
    } catch (error) {
        responseHandler.handleError(error);
        return false;
    }
};

export const getTokenOrders = async({ commit, dispatch }, payload) => {
    dispatch("setLoading", true, { root: true });
    try {
        const response = await api.getTokenOrders(payload);
        const { orders, total, page, pages } = response.data.data;
        commit("SET_ORDER_BOOK", orders);
        commit("SET_TOTAL_ORDERS", total);
        commit("SET_ORDER_PAGE", page);
        commit("SET_ORDER_PAGES", pages);
        dispatch("setLoading", false, { root: true });
        return response;
    } catch (error) {
        dispatch("setLoading", false, { root: true });
        responseHandler.handleError(error);
        return error;
    }
};

export const cancelOrder = async({ dispatch }, payload) => {
    dispatch("setLoading", true, { root: true });
    try {
        const response = await api.cancelOrder(payload);
        dispatch("setLoading", false, { root: true });
        return response;
    } catch (error) {
        dispatch("setLoading", false, { root: true });
        responseHandler.handleError(error);
        return error;
    }
};

export const getTokens = async({ commit, dispatch }, payload) => {
    dispatch("setSmallLoading", true, { root: true });
    try {
        const response = await api.getTokens(payload);
        const { tokens, page, pages } = response.data.data;
        commit("SET_USER_TOKEN", tokens);
        commit("SET_TOKEN_PAGE", page);
        commit("SET_TOKEN_PAGES", pages);
        dispatch("setSmallLoading", false, { root: true });
        return true;
    } catch (error) {
        responseHandler.handleError(error);
        dispatch("setSmallLoading", false, { root: true });
        return false;
    }
};

export const getCompaniesRaising = async({ commit, dispatch }, payload) => {
    dispatch("setSmallLoading", true, { root: true });
    try {
        const response = await api.getCompaniesRaising(payload);
        const { tokens, page, pages } = response.data.data;
        commit("SET_COMPANIES_RAISING", tokens);
        if (payload.page === 1 && router.currentRoute.value.name !== "Invest") {
            commit("SET_RECENT_RAISING", tokens);
        }
        commit("SET_RAISING_PAGE", page);
        commit("SET_RAISING_PAGES", pages);
        dispatch("setSmallLoading", false, { root: true });
        return true;
    } catch (error) {
        dispatch("setSmallLoading", false, { root: true });
        responseHandler.handleError(error);
        return false;
    }
};

export const getCompaniesRaised = async({ commit, dispatch }, payload) => {
    dispatch("setSmallLoading", true, { root: true });
    try {
        const response = await api.getCompaniesRaised(payload);
        const { tokens, page, pages } = response.data.data;
        commit("SET_COMPANIES_RAISED", tokens);
        commit("SET_RAISED_PAGE", page);
        commit("SET_RAISED_PAGES", pages);
        dispatch("setSmallLoading", false, { root: true });
        return true;
    } catch (error) {
        dispatch("setSmallLoading", false, { root: true });
        responseHandler.handleError(error);
        return false;
    }
};

export const getOrderBook = async({ commit, dispatch }, payload) => {
    dispatch("setSmallLoading", true, { root: true });
    try {
        const response = await api.getOrderBooks(payload);
        const { orders, total, page, pages } = response.data.data;
        commit("SET_ORDER_BOOK", orders);
        commit("SET_TOTAL_ORDERS", total);
        commit("SET_ORDER_PAGE", page);
        commit("SET_ORDER_PAGES", pages);
        dispatch("setSmallLoading", false, { root: true });
        return true;
    } catch (error) {
        dispatch("setSmallLoading", false, { root: true });
        responseHandler.handleError(error);
        return false;
    }
};

export const getTokenBalance = async({ commit }, payload) => {
    try {
        const response = await api.getTokenBalance(payload);
        const { data } = response.data;
        commit("SET_TOKEN_BALANCE", data);
        return data;
    } catch (error) {
        responseHandler.handleError(error);
        return false;
    }
};

export const getSingleToken = async({ commit, dispatch }, payload) => {
    dispatch("setSmallLoading", true, { root: true });
    try {
        const response = await api.getSingleToken(payload);
        const { data } = response.data;
        commit("SET_SINGLE_TOKEN", data);
        dispatch("setSmallLoading", false, { root: true });
        return true;
    } catch (error) {
        dispatch("setSmallLoading", false, { root: true });
        responseHandler.handleError(error);
        return false;
    }
};

export const getCompanyUpdate = async({ commit }, payload) => {
    try {
        const response = await api.getCompanyUpdate(payload);
        const { updates, page, pages } = response.data.data;
        commit("SET_COMPANY_UPDATE", updates);
        commit("SET_COMPANY_UPDATE_PAGE", page);
        commit("SET_COMPANY_UPDATE_PAGES", pages);
        return true;
    } catch (error) {
        responseHandler.handleError(error);
        return false;
    }
};

export const deleteDocument = async({ dispatch }, payload) => {
    try {
        const response = await api.deleteDocument(payload);
        await dispatch("getAsset", payload.assetId);
        return true;
    } catch (error) {
        responseHandler.handleError(error);
        return false;
    }
};

export const verifyTokenSymbol = async({ dispatch }, payload) => {
    try {
        if (!payload) return;
        const response = await api.verifyTokenSymbol(payload);
        const { total } = response.data.data;
        // await dispatch("getAsset", payload.assetId);
        return total;
    } catch (error) {
        responseHandler.handleError(error);
        return error;
    }
};